var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcquisitionBp = function SvgAcquisitionBp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AcquisitionBP_svg__a)",
    fill: "#305992"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4 55.053a14.108 14.108 0 0 0 8.4 2.736c3.164 0 6.048-1.012 8.4-2.736v8.894c0 1.56-1.68 2.518-3.052 1.834l-.252-.137-5.096-3.476-5.096 3.476a2.134 2.134 0 0 1-2.128.164 2.112 2.112 0 0 1-1.148-1.56V55.08l-.028-.027ZM68 14v21.895a13.655 13.655 0 0 0-4.2-3.64V18.106H16.2v32.841h28.476l.924.903v3.203H12V14h56ZM55.036 33.267c7.56-1.122 14 5.146 12.824 12.535-.728 4.598-4.564 8.375-9.296 9.086-7.56 1.123-14-5.145-12.824-12.534.728-4.598 4.564-8.375 9.296-9.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9 38.632c1.148 0 2.1.93 2.1 2.052 0 1.04-.784 1.889-1.82 2.026H25.3c-1.148 0-2.1-.931-2.1-2.053 0-1.04.784-1.889 1.82-2.025H37.9ZM54.7 25.44c1.148 0 2.1.93 2.1 2.053 0 1.04-.784 1.888-1.82 2.025H25.3c-1.148 0-2.1-.93-2.1-2.053 0-1.04.784-1.888 1.82-2.025H54.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AcquisitionBP_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 14)",
    d: "M0 0h56v52H0z"
  })))));
};
export default SvgAcquisitionBp;